/*http://www.scriptiny.com/2008/05/javascript-color-fading-script/
This script has been tested in all major browsers and is available free of charge
for both personal or commercial projects under the creative commons license.*/
	
var typeElementToHighlight = '';
var currentHighlightedElement;
var hashCurrentHighlightedItem = '';
var originalColorHighlightedItem = '';
var initialHighlightColor = [255,255,0,1];
var endFading = true;

$(window).on('load', function() {

	if ($(document.body).hasClass('compact')) {
		typeElementToHighlight = 'div';
	} else {
		typeElementToHighlight = 'tr';
	}

	// highlight item's text if there is an anchor on page load
	if (window.location.hash != '') {
		var hash = window.location.hash;
		// only if respective element is present
		if ( $(hash).length && hash.substr(0,5) == '#item' ) {
			hashHighlight(hash);
			// don't forget there is a fixed header
			adjustOffsetHtmlAnchor(hash);
		}
	}
	
	// highlight respective item's text when a headline (on the map) is clicked
	$(document).on('click','.leaflet-popup-content a', function() {
		var href = $(this).attr('href');
		
		// only one item highlighted at a time, same item can be re-highlighted
		if ( $(href).length && endFading ) {
			hashHighlight(href);
			var offset = $(href).offset();
			// don't forget there is a fixed header
			adjustOffsetHtmlAnchor(href);
		}
	});
	
});

function hashHighlight(anchorTag) {

	hashCurrentHighlightedItem = anchorTag;

	endFading = false;

	if (typeElementToHighlight == 'div') {
		// support parent .news and .breaking
		var elementToHighlight = $(anchorTag).parent(typeElementToHighlight);

		//open het item als deze gesloten is
		$(anchorTag).find('.openNewsItemArrow').click();
	} else if (typeElementToHighlight == 'tr') {
		var elementToHighlight = $(anchorTag).closest(typeElementToHighlight);
	}
	
	if (!($(elementToHighlight).length)) {
		return false; // element bestaat niet
	}

	// reset previously hightlighted item
	if ( currentHighlightedElement !== 'undefined' ) {
		$(currentHighlightedElement).css('background-color', originalColorHighlightedItem);
	}

	originalColorHighlightedItem = $(elementToHighlight).css('background-color');

	currentHighlightedElement = elementToHighlight;

	var endColorRGB = RGBtextToRGB(originalColorHighlightedItem);
	if ( originalColorHighlightedItem == 'transparent' || originalColorHighlightedItem == 'rgba(0, 0, 0, 0)' ) {
		// keep part of highlightcolor when animation is over
		
		endColorRGB[0] = 1;
		endColorRGB[1] = 1;
		endColorRGB[2] = 0.6;
		endColorRGB[3] = 0.4;
		colorFade(elementToHighlight, initialHighlightColor, endColorRGB, true);
	} else {
		// keep part of highlightcolor when animation is over
		endColorRGB[0] *= 1;
		endColorRGB[1] *= 1;
		endColorRGB[2] *= 0.6;
		colorFade(elementToHighlight, initialHighlightColor, endColorRGB, false);
	}

}

function colorFade(id,startColor,endColor,transparent) {
	// 30 x 100ms = 3 seconds animation
	var steps = 30;
	var speed = 100;

	var deltaColor = new Object();
	var target = new Object();
	
	target.r = startColor[0];
	target.g = startColor[1];
	target.b = startColor[2];
	target.a = startColor[3];
	
	deltaColor[0] = Math.round((target.r-endColor[0])/steps);
	deltaColor[1] = Math.round((target.g-endColor[1])/steps);
	deltaColor[2] = Math.round((target.b-endColor[2])/steps);
	deltaColor[3] = (target.a-endColor[3])/steps;
	
	target.step = 1;
	target.timer = setInterval(function() {
	    animateColor(id,target,steps,endColor,deltaColor,transparent);
	}, speed);
}

// incrementally close the gap between the two colors
function animateColor(id,target,steps,endColor,deltaColor,transparent) {
	var color;
	if(target.step <= steps) {
		if (transparent) {
			target.a = target.a - deltaColor[3];
			color = 'rgba(' + target.r + ',' + target.g + ',' + target.b + ',' + target.a + ')';
			$(id).css('background-color',color);
		} else {
			target.r = target.r - deltaColor[0];
			target.g = target.g - deltaColor[1];
			target.b = target.b - deltaColor[2];
			
			color = 'rgb(' + target.r + ',' + target.g + ',' + target.b + ')';
			
			$(id).css('background-color',color);
		}
		target.step++;
	} else {
		if (transparent) {
			color = 'rgba(' + endColor[0] + ',' + endColor[1] + ',' + endColor[2] + ',' + endColor[3] + ')';
			$(id).css('background-color',color);
		} else {
			color = 'rgb(' + endColor[0] + ',' + endColor[1] + ',' + endColor[2] + ')';
			$(id).css('background-color',color);
		}
		clearInterval(target.timer);
		endFading = true;
	}
}

// String 'rgb(2,3,4)' or 'rgba(2,3,4,5)' to array [2,3,4] or [2,3,4,5]
function RGBtextToRGB(RGBtext) {

	RGBtext = RGBtext.substr( RGBtext.indexOf('(') + 1 ); // 'rgb(' of 'rgba(' eraf halen
	RGBtext = RGBtext.substr(0, RGBtext.length-1); // laatste ')' eraf halen
	var rgb = RGBtext.split(',');
	rgb[0] = parseInt(rgb[0]);
	rgb[1] = parseInt(rgb[1]);
	rgb[2] = parseInt(rgb[2]);
	if (rgb.length == 4) {
		rgb[3] = parseInt(rgb[3]);
	}

	return rgb;
}

// Adjusts offset of anchor to account for the fixed header
// IN: # + id of anchor
function adjustOffsetHtmlAnchor(hash) {
	var offsetHeader = $('header').height();
	var offsetAnchor = $(hash).offset().top;
	$('html, body').animate({ scrollTop: offsetAnchor - offsetHeader });
}
